import { drawerAtom } from '@/store/drawer-atom';
import { useAtom } from 'jotai';

export type DrawerView =
  | 'cart'
  | 'FILTER_VIEW'
  | 'MAIN_MENU_VIEW'
  | 'AUTH_MENU_VIEW'
  | 'SEARCH_FILTER'
  | 'MAINTENANCE_MORE_INFO';

export const useDrawer = ({
  atom = drawerAtom,
}: {
  atom?: typeof drawerAtom;
}) => {
  const [_, setDrawerState] = useAtom(atom);

  const openDrawer = (view: DrawerView, data?: any) => {
    setDrawerState({ display: true, view, data });
  };

  const closeDrawer = () => {
    setDrawerState({ display: false, view: '' });
  };

  return {
    openDrawer,
    closeDrawer,
  };
};
